import jsonServerProvider from 'ra-data-json-server';
import httpClient from './httpClient';
const apiUrl = process.env.REACT_APP_API_URL;

export const dataProvider = jsonServerProvider(apiUrl, httpClient);
